import { langs } from "components/utils/option";
import { langProps } from "interface/index";
import i18n from "locales/i18n";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAddInfSubmitForm } from "./service";
// import Input from "components/rows/input";
import useMultiLangStore from "store/multiLang";
import Editor from "components/editor/editor";
import TableRow from "components/rows/tableRow";
import Input from "components/rows/input";

type LangStatus =
  | "saved" // 저장 완료 (등록됨)
  | "editing" // 입력/수정 중
  | "empty" // 미입력 (미등록)
  | "error"; // 저장 실패

type IPorps = {
  inf: any;
  updateAble?: string;
  formTyp: "create" | "update" | "read";
  formId: string;
};

export default function MultilingualForm({
  inf,
  updateAble = "false",
  formTyp,
  formId,
}: IPorps) {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const multiLang = useMultiLangStore((state) => state.multiLang);

  const dataTyp =
    (multiLang === inf?.langCd && formTyp !== "read") || formTyp === "create"
      ? "C"
      : "R";

  const langGrp = (code: string) => {
    const langGrp = langs.find((lang) => lang.code === code);

    return langGrp ? langGrp[langCd as keyof langProps] : "";
  };
  const formRefList = useRef<Record<string, HTMLFormElement | null>>({});

  const { onAddInfSubmit } = useAddInfSubmitForm();

  const langBtnTxt =
    formTyp === "read"
      ? ""
      : formTyp === "update"
      ? multiLang === inf.langCd
        ? "수정"
        : ""
      : "등록";

  const isRequired = formTyp === "create" ? "dot" : "";

  return (
    <form
      key={multiLang}
      // data-langcd={inf.langCd}
      data-type={formTyp}
      // data-saved={}
      id={formId}
      ref={(el) => {
        if (el) {
          formRefList.current[inf?.langCd] = el;
        }
      }}
      onSubmit={onAddInfSubmit}
      onReset={() => {}}
    >
      <table>
        <thead>
          <tr>
            <th className="w-full flex justify-between" colSpan={2}>
              <div className="flex gap-2">
                <span>{langGrp(inf?.langCd)}</span>
                {/* {inf?.langCd === multiLang && (
                  <span className="text-red-300 font-bold">[{langStatus}]</span>
                )} */}
              </div>

              {/* 등록된 데이터 보여주기만 할때 버튼은 hidden 작성중일때 able */}
              {!!langBtnTxt && (
                <button className="text-red-300 font-bold" type="submit">
                  [ {langBtnTxt} ]
                </button>
              )}
              {/* )} */}
            </th>
          </tr>
        </thead>
        <tbody>
          <TableRow title={""} theadHidden>
            <ul>
              <li className="w-full">
                <label htmlFor={isRequired}>{t("lbl_rm_nm")}</label>
                <Input
                  type={"text"}
                  name={"rmNm"}
                  value={inf?.rmNm ?? ""}
                  styles="w-full"
                  dataType={dataTyp}
                  updateAble={updateAble}
                />
              </li>
              <li className="w-full h-full">
                <label htmlFor={isRequired}>{t("lbl_rm_desc")}</label>
                <Editor
                  name="rmDesc"
                  defaultValue={inf?.rmDesc}
                  dataTyp={dataTyp}
                  updateAble={updateAble}
                  id={inf?.langCd}
                />
              </li>
            </ul>
          </TableRow>
        </tbody>
      </table>
    </form>
  );
}
